import React, { Component } from 'react';
import { formatDate } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';
import { resolveCardImage } from '../../utils/resolveImage';

var Auth = new AuthService();

var RESOLUTION_TEMPLATES = [
  { label: 'Select a template...', value: '' },
  { label: 'Item not received — refund', value: 'Item was not received by the buyer within the expected timeframe. Full refund issued.' },
  { label: 'Item not as described — refund', value: 'Item received did not match the listing description. Full refund issued.' },
  { label: 'Item not as described — partial refund', value: 'Item received differed from listing. Partial refund issued to compensate for the discrepancy.' },
  { label: 'No issue found — release to seller', value: 'After review, the item appears to match the listing. Funds released to seller.' },
  { label: 'Shipping delay — release to seller', value: 'Shipping was delayed but item has been delivered. Funds released to seller.' },
];

class AdminDisputes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disputes: [],
      loading: true,
      expandedId: null,
      detail: null,
      detailLoading: false,
      resolutionOutcome: '',
      resolutionNotes: '',
      resolutionAmount: '',
      resolveLoading: false,
    };
    this.fetchDisputes = this.fetchDisputes.bind(this);
    this.fetchDetail = this.fetchDetail.bind(this);
    this.handleResolve = this.handleResolve.bind(this);
  }

  componentDidMount() {
    this.fetchDisputes();
  }

  fetchDisputes() {
    var self = this;
    self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/disputes')
      .then(function(data) { self.setState({ disputes: data.disputes, loading: false }); })
      .catch(function(err) { console.log('Failed to fetch disputes:', err); self.setState({ loading: false }); });
  }

  fetchDetail(id) {
    var self = this;
    self.setState({ detailLoading: true, detail: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/disputes/' + id)
      .then(function(data) { self.setState({ detail: data.dispute, detailLoading: false }); })
      .catch(function(err) { console.log('Failed to fetch dispute detail:', err); self.setState({ detailLoading: false }); });
  }

  handleResolve(id) {
    var self = this;
    self.setState({ resolveLoading: true });
    var body = {
      outcome: self.state.resolutionOutcome,
      notes: self.state.resolutionNotes,
    };
    if (self.state.resolutionOutcome === 'partial_refund') {
      body.amount = parseFloat(self.state.resolutionAmount);
    }
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/disputes/' + id + '/resolve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function() {
        self.setState({ resolveLoading: false, expandedId: null, detail: null, resolutionOutcome: '', resolutionNotes: '', resolutionAmount: '' });
        self.fetchDisputes();
      })
      .catch(function(err) {
        self.setState({ resolveLoading: false });
        alert('Failed to resolve dispute: ' + (err.message || 'Unknown error'));
      });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var disputes = this.state.disputes;

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <div className="tw-text-center">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
            <span className="tw-text-sm tw-text-[#999]">Loading...</span>
          </div>
        </div>
      );
    }

    if (disputes.length === 0) {
      return (
        <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#064e3b' : '#ECFDF5' }}>
            <i className="fa fa-check tw-text-2xl" style={{ color: '#10B981' }} />
          </div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">All Clear</h3>
          <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-1">No active disputes to review</p>
        </div>
      );
    }

    return (
      <div className="tw-space-y-3">
        <div className="tw-px-1 tw-mb-2">
          <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{disputes.length} dispute{disputes.length !== 1 ? 's' : ''} requiring attention</span>
        </div>
        {disputes.map(function(tx) {
          var ageMs = Date.now() - new Date(tx.disputedAt).getTime();
          var ageDays = Math.floor(ageMs / (1000 * 60 * 60 * 24));
          var ageLabel = ageDays === 0 ? 'Today' : ageDays + 'd ago';
          var postImage = tx.post && (resolveCardImage(tx.post.cardImage) || (tx.post.images && tx.post.images[0] && resolveCardImage(tx.post.images[0])));
          var urgent = ageDays >= 3;
          var isExpanded = self.state.expandedId === tx._id;

          return (
            <div key={tx._id} className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              {urgent && <div style={{ height: 3, backgroundColor: '#EF4444' }} />}
              <div className="tw-p-4">
                <div className="tw-flex tw-gap-4">
                  {postImage && (
                    <img src={postImage} alt="" className="tw-w-16 tw-h-20 tw-object-cover tw-rounded-lg tw-flex-shrink-0" />
                  )}
                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
                      <div>
                        <h3 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-truncate">{tx.post ? tx.post.title : 'Deleted Post'}</h3>
                        <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5">${(tx.sellerPayout || 0).toFixed(2)} via {tx.paymentMethod} &middot; Order #{tx._id.slice(-8)}</p>
                      </div>
                      <span className="tw-text-xs tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-flex-shrink-0" style={{ backgroundColor: urgent ? (isDark ? '#7f1d1d' : '#FEE2E2') : (isDark ? '#78350f' : '#FEF3C7'), color: urgent ? (isDark ? '#fca5a5' : '#991B1B') : (isDark ? '#fcd34d' : '#92400E') }}>
                        {ageLabel}
                      </span>
                    </div>
                    <div className="tw-flex tw-gap-4 tw-mt-2 tw-text-xs tw-text-[#666] dark:tw-text-[#aaa]">
                      <span>
                        <strong>Buyer:</strong>{' '}
                        <span className="tw-cursor-pointer hover:tw-underline" style={{ color: '#D4A843' }} onClick={function() { if (self.props.onOpenUserModal && tx.buyer) self.props.onOpenUserModal(tx.buyer._id); }}>
                          {tx.buyer ? tx.buyer.userName : 'Guest'}
                        </span>
                      </span>
                      <span>
                        <strong>Seller:</strong>{' '}
                        <span className="tw-cursor-pointer hover:tw-underline" style={{ color: '#D4A843' }} onClick={function() { if (self.props.onOpenUserModal && tx.seller) self.props.onOpenUserModal(tx.seller._id); }}>
                          {tx.seller ? tx.seller.userName : 'Unknown'}
                        </span>
                      </span>
                    </div>
                    <div className="tw-mt-2 tw-px-3 tw-py-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#450a0a' : '#FEF2F2' }}>
                      <span className="tw-text-xs tw-font-medium" style={{ color: isDark ? '#fca5a5' : '#991B1B' }}>Reason: </span>
                      <span className="tw-text-xs" style={{ color: isDark ? '#fecaca' : '#7F1D1D' }}>{tx.disputeReason || 'No reason provided'}</span>
                    </div>
                    <div className="tw-mt-3 tw-flex tw-gap-2 tw-flex-wrap">
                      <button
                        className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90"
                        style={{ backgroundColor: '#8B5CF6' }}
                        onClick={function() {
                          if (isExpanded) {
                            self.setState({ expandedId: null, detail: null });
                          } else {
                            self.setState({ expandedId: tx._id, resolutionOutcome: '', resolutionNotes: '', resolutionAmount: '' });
                            self.fetchDetail(tx._id);
                          }
                        }}
                      >
                        <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-gavel') + ' tw-mr-1'} />
                        {isExpanded ? 'Close' : 'Review & Resolve'}
                      </button>
                      <button
                        className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90"
                        style={{ backgroundColor: '#10B981' }}
                        onClick={function() { self.props.onConfirm({ type: 'release', txId: tx._id, title: tx.post ? tx.post.title : 'this order' }); }}
                      >
                        <i className="fa fa-check tw-mr-1" />Release to Seller
                      </button>
                      <button
                        className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90"
                        style={{ backgroundColor: '#EF4444' }}
                        onClick={function() { self.props.onConfirm({ type: 'refund', txId: tx._id, title: tx.post ? tx.post.title : 'this order' }); }}
                      >
                        <i className="fa fa-undo tw-mr-1" />Refund Buyer
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Expanded Detail & Resolution */}
              {isExpanded && (
                <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-p-4" style={{ backgroundColor: isDark ? '#111' : '#fafafa' }}>
                  {self.state.detailLoading && (
                    <div className="tw-text-center tw-py-6">
                      <i className="fa fa-circle-o-notch fa-spin tw-text-xl" style={{ color: '#D4A843' }} />
                    </div>
                  )}

                  {!self.state.detailLoading && self.state.detail && (
                    <div>
                      {/* Timeline */}
                      <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-3">Timeline</h4>
                      <div className="tw-space-y-2 tw-mb-4">
                        <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                          <div className="tw-w-2 tw-h-2 tw-rounded-full" style={{ backgroundColor: '#10B981' }} />
                          <span className="tw-text-[#999]">{formatDate(self.state.detail.createdAt)}</span>
                          <span className="tw-text-[#666] dark:tw-text-[#aaa]">Order placed</span>
                        </div>
                        {self.state.detail.shippedAt && (
                          <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                            <div className="tw-w-2 tw-h-2 tw-rounded-full" style={{ backgroundColor: '#3B82F6' }} />
                            <span className="tw-text-[#999]">{formatDate(self.state.detail.shippedAt)}</span>
                            <span className="tw-text-[#666] dark:tw-text-[#aaa]">Shipped{self.state.detail.trackingNumber ? ' — ' + self.state.detail.trackingNumber : ''}</span>
                          </div>
                        )}
                        {self.state.detail.deliveredAt && (
                          <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                            <div className="tw-w-2 tw-h-2 tw-rounded-full" style={{ backgroundColor: '#10B981' }} />
                            <span className="tw-text-[#999]">{formatDate(self.state.detail.deliveredAt)}</span>
                            <span className="tw-text-[#666] dark:tw-text-[#aaa]">Delivered</span>
                          </div>
                        )}
                        <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs">
                          <div className="tw-w-2 tw-h-2 tw-rounded-full" style={{ backgroundColor: '#EF4444' }} />
                          <span className="tw-text-[#999]">{formatDate(self.state.detail.disputedAt)}</span>
                          <span className="tw-font-medium" style={{ color: '#EF4444' }}>Dispute opened: {self.state.detail.disputeReason}</span>
                        </div>
                      </div>

                      {/* Admin Notes on Order */}
                      {self.state.detail.adminNotes && self.state.detail.adminNotes.length > 0 && (
                        <div className="tw-mb-4">
                          <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-2">Admin Notes</h4>
                          <div className="tw-space-y-2">
                            {self.state.detail.adminNotes.map(function(n, i) {
                              return (
                                <div key={i} className="tw-p-2 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#222' : '#eee') }}>
                                  <div className="tw-flex tw-items-center tw-gap-2 tw-mb-0.5">
                                    <span className="tw-text-[10px] tw-font-semibold" style={{ color: '#D4A843' }}>{n.addedBy ? n.addedBy.userName : 'Admin'}</span>
                                    <span className="tw-text-[10px] tw-text-[#999]">{n.createdAt ? formatDate(n.createdAt) : ''}</span>
                                  </div>
                                  <p className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-m-0">{n.note}</p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* Resolution Form */}
                      <div className="tw-p-4 tw-rounded-lg" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#ddd') }}>
                        <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-3">
                          <i className="fa fa-gavel tw-mr-1" style={{ color: '#8B5CF6' }} />Resolve Dispute
                        </h4>
                        <div className="tw-mb-3">
                          <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Outcome</label>
                          <select
                            className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                            style={isDark ? { colorScheme: 'dark' } : {}}
                            value={self.state.resolutionOutcome}
                            onChange={function(e) { self.setState({ resolutionOutcome: e.target.value }); }}
                          >
                            <option value="">Select outcome...</option>
                            <option value="refunded">Full Refund to Buyer</option>
                            <option value="released_to_seller">Release to Seller</option>
                            <option value="partial_refund">Partial Refund</option>
                          </select>
                        </div>
                        {self.state.resolutionOutcome === 'partial_refund' && (
                          <div className="tw-mb-3">
                            <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Refund Amount ($)</label>
                            <input
                              type="number"
                              step="0.01"
                              min="0.01"
                              className="tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                              style={{ maxWidth: 200 }}
                              placeholder="0.00"
                              value={self.state.resolutionAmount}
                              onChange={function(e) { self.setState({ resolutionAmount: e.target.value }); }}
                            />
                          </div>
                        )}
                        <div className="tw-mb-3">
                          <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Template</label>
                          <select
                            className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                            style={isDark ? { colorScheme: 'dark' } : {}}
                            value=""
                            onChange={function(e) { if (e.target.value) self.setState({ resolutionNotes: e.target.value }); }}
                          >
                            {RESOLUTION_TEMPLATES.map(function(t, i) {
                              return <option key={i} value={t.value}>{t.label}</option>;
                            })}
                          </select>
                        </div>
                        <div className="tw-mb-3">
                          <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Resolution Notes</label>
                          <textarea
                            className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-resize-none tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                            rows={3}
                            placeholder="Notes about the resolution..."
                            value={self.state.resolutionNotes}
                            onChange={function(e) { self.setState({ resolutionNotes: e.target.value }); }}
                          />
                        </div>
                        <button
                          className="tw-text-xs tw-px-5 tw-py-2.5 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                          style={{
                            backgroundColor: '#8B5CF6',
                            opacity: (!self.state.resolutionOutcome || self.state.resolveLoading || (self.state.resolutionOutcome === 'partial_refund' && (!self.state.resolutionAmount || parseFloat(self.state.resolutionAmount) <= 0))) ? 0.4 : 1,
                            cursor: (!self.state.resolutionOutcome || self.state.resolveLoading) ? 'not-allowed' : 'pointer',
                          }}
                          disabled={!self.state.resolutionOutcome || self.state.resolveLoading || (self.state.resolutionOutcome === 'partial_refund' && (!self.state.resolutionAmount || parseFloat(self.state.resolutionAmount) <= 0))}
                          onClick={function() { self.handleResolve(tx._id); }}
                        >
                          {self.state.resolveLoading ? <i className="fa fa-spinner fa-spin" /> : <span><i className="fa fa-check-square tw-mr-1" />Resolve Dispute</span>}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default AdminDisputes;
